import { render, staticRenderFns } from "./Autonym.vue?vue&type=template&id=73c3b130&scoped=true&"
import script from "./Autonym.vue?vue&type=script&lang=js&"
export * from "./Autonym.vue?vue&type=script&lang=js&"
import style0 from "./Autonym.vue?vue&type=style&index=0&id=73c3b130&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c3b130",
  null
  
)

export default component.exports